import { render, staticRenderFns } from "./give-proudly-ForgotPasswordCode.vue?vue&type=template&id=60fb5f3e&scoped=true"
import script from "./give-proudly-ForgotPasswordCode.vue?vue&type=script&lang=js"
export * from "./give-proudly-ForgotPasswordCode.vue?vue&type=script&lang=js"
import style0 from "./give-proudly-ForgotPasswordCode.vue?vue&type=style&index=0&id=60fb5f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fb5f3e",
  null
  
)

export default component.exports